import script from "./ErrorModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ErrorModal.vue?vue&type=script&setup=true&lang=ts"

import "./ErrorModal.vue?vue&type=style&index=0&id=520af11c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-520af11c"]])

export default __exports__